import { formatUSD } from '../../helpers';
import AnalyticsSmallCard from './AnalyticsSmallCard';
// import useAnalytics from '../../hooks/analytics/useAnalytics';
import useMockAnalytics from '../../hooks/analytics/useMockAnalytics';

const LongPositions = () => {
    const { analytics, defaultData, isLoading } = useMockAnalytics();

    return (
        <AnalyticsSmallCard
            title='Long Positions'
            percentageDifference={
                analytics ? analytics.longPositions.dailyDiffPercentage.toString() : '0'
            }
            amount={formatUSD(analytics?.longPositions.currentValue.toString() || '0', {
                maxDecimals: 0,
            })}
            data={analytics?.longPositions.historicalData ?? defaultData}
            isLoading={isLoading}
        />
    );
};

export default LongPositions;
